import { theme } from '@/theme/theme'
import { PhishingSimulation } from '@/types/phishingSimulations'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faAngleUp } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Typography, styled } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PackageCard from '@/common/components/PackageCard'
import { EducationModule } from '@/api/education-modules/modules'
import { byPrefixAndName } from '@awesome.me/kit-39de79544e/icons'

type PackagePreviewProps = {
  setPreview: (e: boolean) => void
  packageName?: string
  assets?: PhishingSimulation[] | EducationModule[]
  maxHeight: number
}
const PackagePreview: FC<PackagePreviewProps> = ({ setPreview, assets, packageName, maxHeight }) => {
  const { t } = useTranslation()

  return (
    <StyledMainPreviewBox>
      <StyledInnerPreviewBox maxHeight={maxHeight}>
        <StyledTopwBox>
          <Typography
            color={theme.palette.white}
            fontSize={18}
            fontWeight={theme.typography.fontWeightBold}
            paddingBottom={'16px'}>
            {t('package.preview.title', {
              packageType: (assets?.[0] as PhishingSimulation)?.vectors ? 'Simuilation' : 'Video',
            })}
          </Typography>
          <FontAwesomeIcon
            icon={
              byPrefixAndName.fak[
                (assets?.[0] as PhishingSimulation)?.vectors ? 'simulation-package-icon' : 'property-1-video'
              ] as IconProp
            }
            fontSize={72}
            color={theme.palette.cyan[500]}
            style={{
              mask: 'linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 90%)',
            }}
          />
          {assets && assets.length > 1 && (
            <Typography color={theme.palette.white} fontSize={16} padding={theme.spacing(2, 3, 0)} align="center">
              <b>{assets?.length}</b>
              {t('package.preview.includes', {
                packageType: (assets?.[0] as PhishingSimulation)?.vectors ? 'Simuilations' : 'Videos',
              })}
            </Typography>
          )}
          <Typography
            color={theme.palette.white}
            fontSize={18}
            fontWeight={theme.typography.fontWeightBold}
            padding={3}>
            {packageName || t('simulationPackage.defaultPackageName')}
          </Typography>
        </StyledTopwBox>
        <StyledCardsContainerBox>
          {assets?.map((asset, index) => (
            <PackageCard key={asset.id} asset={asset} index={index + 1} />
          ))}
        </StyledCardsContainerBox>
        <FontAwesomeIcon
          color={theme.palette.white}
          fontSize={32}
          style={{ cursor: 'pointer' }}
          icon={faAngleUp as IconProp}
          onClick={() => {
            setPreview && setPreview(false)
          }}
        />
      </StyledInnerPreviewBox>
    </StyledMainPreviewBox>
  )
}

const StyledInnerPreviewBox = styled(Box)(({ maxHeight }: { maxHeight: number }) => ({
  width: '100%',
  padding: '20px',
  maxHeight: maxHeight - 294 + 'px',
  background: theme.palette.blueGray[800],
  borderRadius: '15px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}))

const StyledMainPreviewBox = styled(Box)(() => ({
  width: '100%',
  height: '211px',
  background: 'red',
  borderRadius: '15px',
}))

const StyledTopwBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}))

const StyledCardsContainerBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'scroll',
  overflowX: 'hidden',
  height: '100%',
  width: '100%',
  padding: '0px 10px',
  marginBottom: '20px',
  alignItems: 'stretch',
}))
export default PackagePreview
